// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chargebacks-page {
  padding: 20px;
}
.chargebacks-page .actions,
.chargebacks-page .filters {
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/app/main/data/chargebacks/index.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAFA;;EAKI,mBAAA;AACJ","sourcesContent":[".chargebacks-page {\n  padding: 20px;\n\n  .actions,\n  .filters {\n    margin-bottom: 20px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
